import { tagGroups } from "@/mocks/navData";

const MOOD_STYLE: Record<string, { chip: string; dot: string }> = {
  正热: { chip: "bg-[#e4562b]/10 text-[#e4562b]", dot: "bg-[#e4562b]" },
  想找: { chip: "bg-[#c6903f]/10 text-[#a87624]", dot: "bg-[#c6903f]" },
  慢慢看: { chip: "bg-[#8a6a45]/10 text-[#7a5c38]", dot: "bg-[#8a6a45]" },
  轻松点: { chip: "bg-[#6d8f6a]/10 text-[#547f50]", dot: "bg-[#6d8f6a]" },
};

export default function TagWall() {
  return (
    <section id="tags" className="scroll-mt-20 bg-[#f3e6d1]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
          {/* heading column */}
          <div className="w-full shrink-0 lg:w-[300px]">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#b0843f]">
                <i className="ri-price-tag-3-line text-sm"></i>
                话题标签墙
              </span>
              <h2 className="mt-4 text-3xl font-bold leading-tight text-[#2a2016] md:text-4xl">
                想找哪一片瓜？
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-[#6b5d48]">
                按当下心情挑一串标签，把想找的内容一次性归拢。
                标签下面都挂着直达入口，点开即是正文，不绕弯。
              </p>
              <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#fffdf8] px-4 py-2 text-xs text-[#8a7c64]">
                <i className="ri-checkbox-circle-line text-[#b0843f]"></i>
                共 20 组常驻话题，按热度轮换
              </p>
            </div>
          </div>

          {/* mood wall */}
          <div className="grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2">
            {tagGroups.map((group) => {
              const style = MOOD_STYLE[group.label] ?? MOOD_STYLE["慢慢看"];
              return (
                <div
                  key={group.label}
                  className="rounded-2xl border border-[#ead9bd] bg-[#fffdf8] p-6"
                >
                  <div className="mb-5 flex items-center gap-3">
                    <span className={`h-2.5 w-2.5 rounded-full ${style.dot}`}></span>
                    <h3 className="text-base font-bold text-[#2a2016]">{group.label}</h3>
                    <span
                      className={`ml-auto inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${style.chip}`}
                    >
                      {group.tags.length} 组
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2.5">
                    {group.tags.map((tag) => (
                      <a
                        key={tag}
                        href="#index"
                        className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-[#ead9bd] bg-[#faf5ec] px-3.5 py-1.5 text-sm text-[#6b5d48] transition-colors hover:border-[#e4562b] hover:bg-white hover:text-[#e4562b]"
                      >
                        <span className={`h-1.5 w-1.5 rounded-full ${style.dot}`}></span>
                        {tag}
                      </a>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}